
import dayjs from 'dayjs';
import advancedPlugin from 'dayjs/plugin/advancedFormat'
import { useState } from 'react';

export default function Header() {

    dayjs.extend(advancedPlugin);
    const today = dayjs().format('Do MMMM, YYYY');
  
    const [date, setDate] = useState(today)
  
    return <h1 style={{fontFamily: 'Lora', fontWeight: '200'}}id='header'>{date}</h1>
  }